import { render, staticRenderFns } from "./transactionsTable.vue?vue&type=template&id=bad3fdaa&scoped=true&"
import script from "./transactionsTable.vue?vue&type=script&lang=js&"
export * from "./transactionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad3fdaa",
  null
  
)

export default component.exports